<template>
  <div class="btn_container" :class="btnPosition=='fixed'?'posFixed':'posAbsolute'">
    <div class="btn btn_cancel" :class="isDisabled ? '' : 'disabled'"><slot></slot></div>
  </div>
</template>

<script>
  import scroll from '@/common/scroll'
    export default {
      data(){
        return {
          btnPosition:'fixed'
        }
      },
      props: {
        isDisabled: {
          type: Boolean,
          default: true,
          required: false
        }
      },
      mounted(){
        window.onscroll = ()=>{
          scroll.getScrollBottom(this.setBtnPosAbs,this.setBtnPosFix)
        };
      },
      methods:{
        setBtnPosAbs(){
          this.btnPosition = 'absolute'
        },
        setBtnPosFix(){
          this.btnPosition = 'fixed'
        },
      }
    }
</script>

<style scoped lang="scss">
  .btn_container{
    width:375px;
    height:45px;
    left:0;
    bottom:0;
    @include layout_row_root();
    .btn{
      @include layout_row();
    }
    .btn_cancel{
      @include btnBlue();
      width:375px;
      &.disabled{
        background-color: #CCCCCC;
      }
    }
  }
  .posFixed{
    position: fixed;
  }
  .posAbsolute{
    position: absolute;
  }
</style>



// WEBPACK FOOTER //
// src/components/BtnFixed.vue